import type { Entry, EntryIn, Schemas } from "../api/client";

/** A change made on this device, waiting to be sent to the server. */
export type Op =
  | { kind: "putEntry"; id: string; body: EntryIn; preview: Entry }
  | { kind: "deleteEntry"; id: string; date: string; name: string }
  | { kind: "increment"; key: string; body: Schemas["MetricIncrement"] }
  // Set (or, with null, remove) the day's manual value, e.g. a weigh-in.
  | { kind: "setMetric"; date: string; metric: Schemas["Metric"]; value: number | null }
  | {
      // "Quick add" with "Save to My Foods": create the food, then log it.
      kind: "createFoodAndLog";
      foodKey: string;
      food: Schemas["FoodCreate"];
      entryId: string;
      entry: Omit<EntryIn, "food_id">;
      preview: Entry;
    };

export type QueuedOp = Op & {
  seq: number;
  /** Only this user's session may send it. */
  userId: number;
  createdAt: number;
  attempts: number;
  lastError?: string;
};

/** Sent successfully, but the screen may still be showing data from before. */
export type SettledOp = QueuedOp & { syncedAt: number };

export function describeOp(op: Op): string {
  switch (op.kind) {
    case "putEntry":
      return `${op.preview.name} (${op.preview.meal}, ${op.preview.date})`;
    case "createFoodAndLog":
      return `${op.preview.name} (${op.preview.meal}, ${op.preview.date}), saved to My Foods`;
    case "deleteEntry":
      return `Delete ${op.name} (${op.date})`;
    case "increment":
      return `Water ${op.body.delta > 0 ? "+" : ""}${op.body.delta} ml (${op.body.date})`;
    case "setMetric":
      return op.value == null
        ? `Remove ${op.metric} (${op.date})`
        : `${op.metric === "weight_kg" ? "Weight" : op.metric} ${op.value} (${op.date})`;
  }
}
